import { themedStyled } from 'common/styles/styletron.theme';

export const UsernameContainer = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  marginBottom: $theme.sizing.scale800,
}));

export const PermissionContainer = themedStyled('div', ({ $theme }) => ({}));

export const MainContainer = themedStyled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  width: '100%',
});

export const CenteredContainer = themedStyled('div', {
  minHeight: '400px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const PermissionChildContainer = themedStyled('div', {
  marginLeft: '24px',
  marginBottom: '8px',
});

export const SectionContainer = themedStyled('div', {
  marginBottom: '24px',
});

export const ButtonContainer = themedStyled('div', {
  display: 'flex',
  alignItems: 'flex-end',
  marginTop: '24px',
  justifyContent: 'flex-end',
});

export const DetailContainer = themedStyled('div', {
  display: 'flex',
  height: '100%',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
});

export const AdminActionContainer = themedStyled('div', {
  display: 'flex',
  flex: 1,
  marginBottom: '24px',
  justifyContent: 'flex-end',
});
